import React from 'react';
import { useParams } from 'react-router-dom';

import DestaquesComponente from '../../../../../components/Destaques';
import { ENTITY } from '../../../../../utils/entityNames';
import { fieldObjectOrgInters } from '../utils/auxiliarOrgInters';
import SubAbasOrgInters from '../utils/subabasOrgInters';

const OrgIntersDestaques: React.FC = () => {
  const params = useParams();
  const fichaID = String(params.id);

  return (
    <DestaquesComponente
      tab="orgInter"
      id_tab={fichaID}
      retorno="/daf/proaq/orginters"
      arquivo_export="sisaf_orginter_destaques.xlsx"
      fieldObject={fieldObjectOrgInters}
      subAbas={
        fichaID !== 'undefined' ? SubAbasOrgInters(fichaID) : SubAbasOrgInters
      }
      entity={ENTITY.ENTITY_Org_Inter}
    />
  );
};

export default OrgIntersDestaques;
